<template>
  <div class="w-85per dp-inblock">
    <div class="title">
      <h2>신청자 정보</h2>
      <p>
        - 이름, E-mail, 비밀번호는 필수 항목입니다. <br />
        -
        <span class="txt-red"
          >교재비가 있을 시 교재 유무 필수로 체크해주세요.</span
        ><br />
        <span class="txt-red"
          >* 입력박스나 입력했던 값이 안보이는 경우 새로고침하여 진행해 주세요.
          (저장했던 값은 날아가지 않습니다.)</span
        >
      </p>
    </div>
    <div v-if="userInfoList">
      <ag-grid-vue
        style="height: 697px; width: 100%; font-size: 12px"
        @row-drag-enter="onRowDragEnter"
        @row-drag-end="onRowDragEnd"
        @row-drag-move="onRowDragMove"
        @row-drag-leave="onRowDragLeave"
        :rowDragManaged="true"
        :animateRows="true"
        class="ag-theme-balham"
        :columnDefs="columnDefs"
        :rowData="userInfoList"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        :frameworkComponents="frameworkComponents"
        :context="context"
        :defaultColDef="defaultColDef"
        rowSelection="multiple"
        @selection-changed="onSelectionChanged"
      >
      </ag-grid-vue>
    </div>
    <div class="mt-10 mb-10">
      <button @click="addUserInfoList()" class="admin-btn-default float-right">
        + 항목 추가
      </button>
    </div>
    <div class="line mt-60"></div>
    <div class="mt-30 w-100per mg-auto">
      <button @click="prev()" class="admin-btn-default">이전</button>
      <button @click="next()" class="admin-btn-default float-right ml-05">
        <span v-if="isFinishPage">완료하기</span>
        <span v-else>다음</span>
      </button>
      <button @click="save()" class="admin-btn-default float-right ml-05">
        저장
      </button>
      <button @click="preview()" class="admin-btn-default float-right">
        미리보기
      </button>
    </div>
    <option-modal
      v-if="isModalOpened"
      :modalIndex="modalIndex"
      :parentOption="parentOption"
      @save="saveOption"
      @close="closeModal"
    ></option-modal>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import {
  InputComponent,
  RequiredComponent,
  ItemComponent,
  InfoTextComponent,
  CustomInputComponent,
} from "@/utils/reg.userInfo.grid.js";
import OptionModal from "@/components/reg/userInfo/optionModal.vue";
export default {
  components: {
    AgGridVue,
    OptionModal,
  },
  data: () => ({
    userInfoList: [],
    userInfoColumns: [],
    isModalOpened: false, // 옵션 선택 모달 on/off
    modalIndex: "", // 몇번 째 행에서 모달 켜졌는지 확인
    parentOption: "", // 사용자 입력 옵션선택 데이터 존재시 전달

    /** ag-grid 옵션 변수들 선언 */
    gridOptions: null, // 그리드에 적용할 각 옵션 (열, 행, 헤더, 편집옵션 등)
    gridApi: null, // 그리드에 적용할 각 api ( 사이즈, get, set, 노드접근, 선택, 정렬 등)
    columnApi: null, // 컬럼에 사용할 각 api ( 행의 사이즈, get, set)
    columnDefs: null, // 컬럼에 들어갈 값 (헤더 데이터)
    rowData: null, // 열에 들어갈 값 (기본 데이터)
    defaultColDef: null, // 기본 컬럼 셋팅 (따로 컬럼에 옵션을 지정하지 않은 경우)
    modules: AllCommunityModules, // Ag-grid 모듈 사용 변수

    isSaved: false, // 저장됬는지 확인 여부(저장되야 미리보기 할 수 있게끔)
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    isFetching: false, // 현재 api 로딩중인지
  }),

  created() {
    // this.makeData()
  },

  beforeMount() {
    this.columnDefs = [
      {
        headerName: "",
        rowDrag: true,
        field: "itemType",
        valueFormatter: () => {
          return "";
        },
        width: 42.5,
      },
      {
        headerName: "입력항목",
        field: "isAddItem",
        // cellRenderer: 'InputComponent',
        checkboxSelection: (params) => {
          if (params.data.isAddItem === "select") {
            if (params.data.useYn === "Y") {
              params.node.setSelected(true);
            }
            return true;
          } else {
            return false;
          }
        },
        valueFormatter: () => {
          return "";
        },
        width: 85,
      },
      {
        headerName: "필수입력",
        field: "isRequired",
        cellRenderer: "RequiredComponent",
        width: 85,
      },
      {
        headerName: "항목",
        field: "itemType",
        cellRenderer: "ItemComponent",
        width: 190,
      },
      {
        headerName: "항목 안내 문구",
        field: "itemMessage",
        cellRenderer: "InfoTextComponent",
        width: 305,
      },
      {
        headerName: "사용자 입력",
        field: "inputType",
        cellRenderer: "CustomInputComponent",
        width: 295,
      },
    ];

    // 그리드에 적용가능한 여러가지 옵션 사항을 설정합니다.
    this.gridOptions = {
      headerHeight: 36,
      rowHeight: 47,
      // enableColResize: true,
      // enableSorting: true,
      // enableFilter: true,
      animateRows: false,
      suppressRowClickSelection: true, // 행 선택 해제
    };

    // 그리드에 적용할 컴포넌트 설정 (utils/reg.userInfo.grid.js 파일에 컴포넌트 지정)
    this.frameworkComponents = {
      InputComponent: "InputComponent",
      RequiredComponent: "RequiredComponent",
      ItemComponent: "ItemComponent",
      InfoTextComponent: "InfoTextComponent",
      CustomInputComponent: "CustomInputComponent",
    };

    // 그리드에 삽입된 외부 컴포넌트에서 현재 컴포넌트 데이터에 접근하기 위함
    this.context = {
      componentParent: this,
    };

    // 기본 컬럼 세팅 정의
    this.defaultColDef = {
      resizable: false, // 컬럼 Width 조정가능
    };
  },

  mounted() {
    this.setUserInfoList();
    if (sessionStorage.getItem("fix")) {
      var pageIdx = sessionStorage.getItem("pageIdx");
      var params = {
        pageIdx: pageIdx,
      };
      this.axios
        .get(
          this.axios.root + this.axios.port + `/sugang/info/${pageIdx}`,
          params,
        )
        .then((res) => {
          if (res.data.err === 108) {
            alert(res.data.result);
          } else {
            var applyUserInfoList = [];
            var remainInfoList = [];

            var itemList = [
              "이름", // 항목 이름
              "비밀번호",
              "휴대전화번호",
              "회사",
              "사업부",
              "부서",
              "직급",
              "사번",
              "첫 수업 희망일정",
              "1순위 희망수업시간",
              "2순위 희망수업시간",
              "주소",
              "상세주소",
              "공인시험점수",
              "1차 소속/ 2차 소속",
            ];
            var userInfoList = JSON.parse(JSON.stringify(this.userInfoList));
            for (var [index, item] of res.data.info.entries()) {
              if (item.item_name === "") continue;
              if (itemList.includes(item.item_name)) {
                for (var partInfo of userInfoList) {
                  if (item.item_name === partInfo.itemName) {
                    if (item.option_info !== "") {
                      partInfo.optionInfo = item.option_info;
                      partInfo.inputType = "direct";
                    }

                    partInfo.itemMessage = item.item_message;
                    partInfo.necessaryYn = item.necessary_YN;
                    partInfo.useYn = item.use_YN;
                    partInfo.idx = item.idx;
                    applyUserInfoList.push(partInfo);
                    break;
                  }
                }
              } else if (item.item_name.includes("E-mail@")) {
                applyUserInfoList.push({
                  idx: item.idx,
                  isAddItem: "required",
                  useYn: item.use_YN,
                  isRequired: "required",
                  necessaryYn: item.necessary_YN,
                  itemName: item.item_name.replace("E-mail@", ""),
                  itemMessage: item.item_message,
                  inputType: "required",
                  optionInfo: "",
                  itemType: "email",
                });
              } else {
                applyUserInfoList.push({
                  idx: item.idx,
                  isAddItem: "select",
                  useYn: item.use_YN,
                  isRequired: "select",
                  necessaryYn: item.necessary_YN,
                  itemName: item.item_name,
                  itemMessage: item.item_message,
                  inputType: "direct",
                  optionInfo: item.option_info,
                  itemType: "",
                });
              }
            }

            // applyUserInfo와 userInfo의 itemName 비교하여 머지
            var mergedList = [];
            var applyItemNames = applyUserInfoList.map(function (item) {
              return item.itemName;
            });

            // applyUserInfoList 항목 먼저 추가
            for (var ai = 0; ai < applyUserInfoList.length; ai++) {
              mergedList.push(applyUserInfoList[ai]);
            }

            // this.userInfoList 중 applyUserInfoList에 없는 itemName만 추가
            for (var ui = 0; ui < userInfoList.length; ui++) {
              if (
                userInfoList[ui].itemName &&
                !applyItemNames.includes(userInfoList[ui].itemName)
              ) {
                mergedList.push(userInfoList[ui]);
              }
            }

            // 이름, 비밀번호, 휴대전화번호, E-mail@ 순서로 0~3 인덱스 고정
            var fixedOrder = ["이름", "비밀번호", "휴대전화번호"];
            var sortedList = [];
            for (var fi = 0; fi < fixedOrder.length; fi++) {
              for (var mi = 0; mi < mergedList.length; mi++) {
                if (mergedList[mi].itemName === fixedOrder[fi]) {
                  sortedList.push(mergedList[mi]);
                  mergedList.splice(mi, 1);
                  break;
                }
              }
            }
            // E-mail@ 항목 (itemType === "email")
            for (var ei = 0; ei < mergedList.length; ei++) {
              if (mergedList[ei].itemType === "email") {
                sortedList.push(mergedList[ei]);
                mergedList.splice(ei, 1);
                break;
              }
            }
            // 나머지 항목 추가 (itemName이 빈 문자열인 항목은 맨 뒤로)
            var namedItems = mergedList.filter(function (item) {
              return item.itemName !== "";
            });
            var emptyItems = mergedList.filter(function (item) {
              return item.itemName === "";
            });
            sortedList = sortedList.concat(namedItems).concat(emptyItems);

            // 수정시 신청자 항목 19개 나오도록 처리
            for (let i = sortedList.length; i < 19; i++) {
              sortedList.push({
                isAddItem: "select",
                useYn: "N",
                isRequired: "select",
                necessaryYn: "N",
                itemName: "",
                itemMessage: "",
                inputType: "direct",
                optionInfo: "direct",
                itemType: "",
              });
            }

            this.userInfoList = JSON.parse(JSON.stringify(sortedList));

            this.gridApi.refreshCells();
            this.gridApi.redrawRows();
          }
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });
    }

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }
  },

  methods: {
    // 리스트 체크박스 선택 여부 이벤트 발생
    onSelectionChanged(event) {
      for (const selectedNode of event.api.getSelectedNodes()) {
        selectedNode.data.useYn = "Y";
      }

      event.api.forEachNode((node, index) => {
        if (!node.selected && node.data.isAddItem === "select") {
          node.data.useYn = "N";
        }
      });
    },

    // 행 드래그 종료시 이벤트 함수
    onRowDragEnd(e) {
      this.gridApi.refreshClientSideRowModel();
      var tempData = [];
      this.gridApi.forEachNode(function (rowNode, index) {
        tempData.push(rowNode.data);
      });

      this.gridApi.refreshCells();
      this.gridApi.redrawRows();

      this.userInfoList = JSON.parse(JSON.stringify(tempData));
      // e.api.refreshCells() // 셀 새로고침
      // e.api.redrawRows() // 셀 스타일 새로고침
    },

    // 그리드 랜더링 완료된 경우 호출 (onGridReady는 mounted 호출 후에 호출됨)
    onGridReady(params) {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;

      // 컬럼 사이즈 재 조정
      params.api.sizeColumnsToFit();

      this.userInfoList = [
        {
          isAddItem: "required", // 입력항목 구분
          useYn: "Y", // 입력항목 값 (required는 항상 true)
          isRequired: "required", // 필수입력 구분
          necessaryYn: "Y", // 필수입력 값 (requied는 항상 true)
          itemName: "이름", // 항목 이름
          itemMessage: "", // 항목 안내 문구 데이터
          inputType: "required", // 사용자 입력 타입 (required는 항상 빈값)
          optionInfo: "", // 직접입력 or 옵션선택
          itemType: "name", // 항목 타입
        },
        {
          isAddItem: "required",
          useYn: "Y",
          isRequired: "required",
          necessaryYn: "Y",
          itemName: "비밀번호",
          itemMessage:
            "영문+숫자 포함 8~12자리로 입력부탁드립니다. ※특수문자 사용 불가",
          inputType: "required",
          optionInfo: "",
          itemType: "password",
        },
        {
          isAddItem: "required",
          useYn: "Y",
          isRequired: "required",
          necessaryYn: "Y",
          itemName: "휴대전화번호",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "phoneNumber",
        },
        {
          isAddItem: "required",
          useYn: "Y",
          isRequired: "required",
          necessaryYn: "Y",
          itemName: "",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "email",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "회사",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "company",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "사업부",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "businessUnit",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "부서",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "department",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "직급",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "jobPosition",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "사번",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "pNumber",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "첫 수업 희망일정",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "date",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "1순위 희망수업시간",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "1stDatetime",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "2순위 희망수업시간",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "2ndDatetime",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "주소",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "address",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "상세주소",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "detailAddress",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "공인시험점수",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "authPoint",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "Y",
          itemName: "1차 소속/ 2차 소속",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "forElectronic",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "",
          itemMessage: "",
          inputType: "direct",
          strType: "direct",
          optionInfo: "direct",
          itemType: "",
        },
      ];
    },

    gridSizeFit(params) {
      // 모니터나 브라우저 크기에 따라 반응하여 그리드 컬럼 사이즈를 조정합니다.
      if (window.innerWidth > 800) {
        params.api.sizeColumnsToFit(); // 가로 스크롤바가 생기지 않도록 컬럼 사이즈를 그리드에 꼭 맞게 조정합니다.
      } else {
        // 컬럼의 데이터값이 잘리지 않도록 조정합니다.
        let allColumnIds = [];
        this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
      }
    },

    // 모달 닫기
    closeModal() {
      this.isModalOpened = false;
    },

    // 미리보기
    preview() {
      if (!this.isSaved) {
        alert("미리보기를 하려면 먼저 저장을 해야합니다.");
        return false;
      }
      let routeData = this.$router.resolve({
        name: "preview-userInfo",
        query: {
          pageIdx: sessionStorage.getItem("pageIdx"),
        },
      });
      window.open(routeData.href, "_blank");
    },

    // 신청자 정보 데이터 저장
    save() {
      if (this.isFetching) {
        alert("저장중입니다...");
        return false;
      }
      var list = JSON.parse(JSON.stringify(this.userInfoList));

      // 파라미터에 맞게 데이터 가공
      for (var [index, item] of list.entries()) {
        // item['idx'] = index
        item["order"] = index;
        if (item["itemType"] === "email") {
          item["itemName"] = "E-mail@" + item["itemName"];
        }
        if (item["itemType"] === "" && item["itemName"] === "E-mail@") {
          alert("동일한 항목은 입력할수 없습니다.");
          this.isFetching = false;
          return false;
        }
        delete item["inputType"];
        delete item["isAddItem"];
        delete item["isRequired"];
        delete item["itemType"];
      }

      var params = {
        idxItmSugangPageMain: sessionStorage.getItem("pageIdx"),
        list: list,
      };

      this.isFetching = true;

      this.axios
        .put(this.axios.root + this.axios.port + "/sugang/info", params)
        .then((res) => {
          this.isFetching = false;
          if (res.data.err === 0) {
            this.isSaved = true;
            for (var [index, item] of res.data.info.entries()) {
              if (this.userInfoList.length > index) {
                this.userInfoList[index].idx = item.idx;
              }
            }
            alert("저장되었습니다.");
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          this.isFetching = false;
          console.error(err);
          alert(err);
        });
    },

    // 사용자 입력 옵션 적용
    saveOption(options, index) {
      this.isModalOpened = false;
      this.userInfoList[index]["optionInfo"] = options;
    },

    // 이전 페이지 이동
    prev() {
      var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
      var idx = pOrder.indexOf("userInfo") - 1;
      this.$router.push(`/admin/reg/${pOrder[idx]}`);
    },

    // 다음 페이지 이동
    next() {
      if (this.isSaved) {
        if (this.isFinishPage) {
          alert("수강신청 등록이 완료되었습니다.");
          this.$router.push("/admin/list/main");
        } else {
          var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
          var idx = pOrder.indexOf("userInfo") + 1;
          sessionStorage.setItem("step", pOrder[idx]);
          this.$router.push(`/admin/reg/${pOrder[idx]}`);
        }
      } else {
        alert("저장을 먼저 해주세요.");
        return false;
      }
    },

    loadSugangInfo() {
      var pageIdx = sessionStorage.getItem("pageIdx");
      var params = {
        pageIdx: pageIdx,
      };
      this.axios
        .get(
          this.axios.root + this.axios.port + `/sugang/info/${pageIdx}`,
          params,
        )
        .then((res) => {
          if (res.data.err === 108) {
            alert(res.data.result);
          } else {
            for (var [index, item] of res.data.info.entries()) {
              this.userInfoList[index].itemMessage = item.item_message;
              this.userInfoList[index].necessaryYn = item.necessary_YN;
              this.userInfoList[index].useYn = item.use_YN;
              this.userInfoList[index].idx = item.idx;
              if (item.item_name.includes("E-mail@")) {
                this.userInfoList[index].itemName = item.item_name.replace(
                  "E-mail@",
                  "",
                );
              }

              if (item.option_info !== "") {
                this.userInfoList[index].optionInfo = item.option_info;
                this.userInfoList[index].inputType = "direct";
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });
    },

    setUserInfoList() {
      this.userInfoList = [
        {
          isAddItem: "required", // 입력항목 구분
          useYn: "Y", // 입력항목 값 (required는 항상 true)
          isRequired: "required", // 필수입력 구분
          necessaryYn: "Y", // 필수입력 값 (requied는 항상 true)
          itemName: "이름", // 항목 이름
          itemMessage: "", // 항목 안내 문구 데이터
          inputType: "required", // 사용자 입력 타입 (required는 항상 빈값)
          optionInfo: "", // 직접입력 or 옵션선택
          itemType: "name", // 항목 타입
        },
        {
          isAddItem: "required",
          useYn: "Y",
          isRequired: "required",
          necessaryYn: "Y",
          itemName: "비밀번호",
          itemMessage: "신청 내역 확인 시 필요.",
          inputType: "required",
          optionInfo: "",
          itemType: "password",
        },
        {
          isAddItem: "required",
          useYn: "N",
          isRequired: "required",
          necessaryYn: "N",
          itemName: "휴대전화번호",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "phoneNumber",
        },
        {
          isAddItem: "required",
          useYn: "Y",
          isRequired: "required",
          necessaryYn: "Y",
          itemName: "",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "email",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "회사",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "company",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "사업부",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "businessUnit",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "부서",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "department",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "직급",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "jobPosition",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "사번",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "pNumber",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "첫 수업 희망일정",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "date",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "1순위 희망수업시간",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "1stDatetime",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "2순위 희망수업시간",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "",
          itemType: "2ndDatetime",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "주소",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "address",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "상세주소",
          itemMessage: "",
          inputType: "required",
          optionInfo: "",
          itemType: "detailAddress",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "공인시험점수",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "authPoint",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "Y",
          itemName: "1차 소속/ 2차 소속",
          itemMessage: "",
          inputType: "direct",
          optionInfo: "direct",
          itemType: "forElectronic",
        },
        {
          isAddItem: "select",
          useYn: "N",
          isRequired: "select",
          necessaryYn: "N",
          itemName: "",
          itemMessage: "",
          inputType: "direct",
          strType: "direct",
          optionInfo: "direct",
          itemType: "",
        },
      ];
    },
    addUserInfoList() {
      this.userInfoList.push({
        isAddItem: "select",
        useYn: "N",
        isRequired: "select",
        necessaryYn: "N",
        itemName: "",
        itemMessage: "",
        inputType: "direct",
        optionInfo: "direct",
        itemType: "",
      });
    },
  },
};
</script>

<style scoped>
/* 셀 선택시 테두리 포커싱 */
div >>> .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  border: 2px solid #3e81f6 !important;
  height: 45px;
}

div >>> .ag-theme-balham .ag-row-selected {
  background-color: inherit;
}

div >>> .ag-theme-balham .ag-ltr .ag-selection-checkbox {
  margin-top: 2px;
  margin-right: 0px;
}

div >>> .ag-theme-balham .ag-ltr .ag-row-drag {
  margin-right: 0px;
}
</style>
